module.exports = __webpack_public_path__ + "static/media/clover.7fe99240.jpg";